import { CountriesAlpha2 } from '@sequencehq/api'
import {
  countriesAlpha2,
  getStateOptions
} from '@sequencehq/api/utils/commonEnums'
import { Address } from '@sequencehq/api/utils/commonModels'

/**
 * The full country list as `{ value, label }` select options. Shared by every
 * invoice billing-address editor so the option list is built once rather than
 * rebuilt inline at each call site.
 */
export const countryOptions = Object.entries(countriesAlpha2).map(
  ([value, label]) => ({
    value,
    label
  })
)

/**
 * Returns the address with its country changed, keeping the current state only
 * when it's a valid option for the new country and clearing it otherwise. This
 * covers both a country with no states at all and a switch between two
 * state-having countries (e.g. US→Canada), where the old state code would
 * otherwise linger and be submitted against the new country.
 */
export const resolveAddressCountryChange = (
  address: Address,
  nextCountry: CountriesAlpha2
): Address => {
  const stateStillValid = getStateOptions(nextCountry).some(
    option => option.value === address.state
  )

  return {
    ...address,
    country: nextCountry,
    state: stateStillValid ? address.state : undefined
  }
}
